import React, { useEffect, useState } from 'react'
import styles from './BestItemBody.module.scss'
import cl from 'classnames'
import { BestItemBodyProps } from './BestItemBody.types'
import { inject } from 'mobx-react'
import { PRODUCTS_MAIN_STORE } from 'store'
import { LoadingSpinner } from 'components/common'
import { HorizontalLine, ImageSquare, Numbers, Text1, Text2 } from 'components/shared'
import { formatPrice, getMainImageSrcForObj } from 'utilities'
import { IconStarFilled } from 'assets'

const BestItemBodyComponent = (props: BestItemBodyProps) => {
  const {
    className,
    style,
    [PRODUCTS_MAIN_STORE]: {
      getProduct
    },
    item
  } = props

  const [product, setProduct] = useState(item.product || null)

  useEffect(() => {
    if (!product) {
      getProduct(item.productId)
        .then(setProduct)
    }
  }, [product, getProduct, item])

  return (
    <div
      className={cl(styles.container, {
        [styles.contentCentered]: !product
      }, className)}
      style={style}
    >
      {product
        ? (
          <>
            <div className={styles.productImagePrice}>
              <ImageSquare
                src={getMainImageSrcForObj(product)}
                width={80}
                className={styles.pictureBorderRadius}
              />

              <Text2 className={styles.price}>
                {formatPrice(product.productSkus[0].price)}
              </Text2>
            </div>
            <div className={styles.productInfo}>
              <Text1 className={styles.productInfoTitle}>
                <IconStarFilled />
                Best item
              </Text1>
              <Text1
                overflowEllipsis
                className={styles.productName}
              >
                {product.name}
              </Text1>
              <HorizontalLine className={styles.line} />
              <div className={styles.statNumberContainer}>
                <Numbers style={{ color: styles.white }}>
                  {item.isPrice
                    ? formatPrice(item.productStatNumber)
                    : item.productStatNumber}
                </Numbers>
                {item.afterStatNumberLabel && (
                  <Text1
                    className={styles.afterStatNumLabel}
                  >
                    {item.afterStatNumberLabel}
                  </Text1>
                )}
              </div>
              {item.showStoreName && (
                <Text2 className={styles.shopName}>
                  {product.brandName}
                </Text2>
              )}
            </div>
          </>
        )
        : <LoadingSpinner show noBackground />}
    </div>
  )
}

const BestItemBody = inject('PRODUCTS_MAIN_STORE')(BestItemBodyComponent)
export { BestItemBody }
